/* eslint-disable no-restricted-globals */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable prefer-template */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable no-use-before-define */
/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react';
import { Field, useFormikContext } from 'formik';
import './textBox.component.css';
import { usePADomainModel } from '../../context/ctxPriorAuthorizationDomain';

interface TextBoxProps {
  name: string;
  label: string;
  id:string;
  type?: string;
  placeHolder?:string;
  onChange: React.ChangeEventHandler<HTMLSelectElement | HTMLInputElement | HTMLTextAreaElement>;
  readonly?:boolean;
  required?:boolean;
  requiredmessage?:string;
  format?:TextBoxFormat;
  convert?:TextBoxConvert;
  hidden?:boolean;
}

interface TextBoxFormat {
  type: string;
  typemessage?: string;
  min?: number;
  minmessage?: string;
  max?: number;
  maxmessage?: string;
}

interface TextBoxConvert {
  type: string;
  format: string;
}

const TextBox: React.FC<TextBoxProps> = ({ name, label, id, type = 'text', placeHolder, onChange, readonly, required, requiredmessage, format, convert, hidden }) => {
  const formik = useFormikContext();
  const [error, setError] = useState('');
  const [displayValue, setDisplayValue] = useState('');

  const { initialValues } = useFormikContext() as any;

  useEffect(() => {
    const initialError = validateInput('');
    setError(initialError);
  }, []);

  useEffect(() => {
    let value = findValueByName(initialValues, id);
    if (convert && value) {
      if (convert.type === 'date' && convert.format) {
        value = formatDate(value, convert.format);
      }
    }
    if (value) {
      const validationError = validateInput(value.toString());
      setError(validationError);
    }
    setDisplayValue(value);
  }, []);

  const { updateFieldValidationStatus } = usePADomainModel();

  function formatDate(dateStr: string, format: string) {
    const date = new Date(dateStr);
    const padZero = (num:number) => (num < 10 ? '0' + num : num.toString());
    const day = padZero(date.getDate());
    const month = padZero(date.getMonth() + 1);
    const fullYear = date.getFullYear().toString();
    const year = fullYear.substring(-2);
    let formattedDate = format.replace('YYYY', fullYear);
    formattedDate = formattedDate.replace('YY', year);
    formattedDate = formattedDate.replace('MM', month).replace('DD', day);

    return formattedDate;
  }

  const findValueByName = (initialValues:any, name:any) => {
    if (initialValues[name]) {
      return initialValues[name];
    }
    if (initialValues.forms) {
      for (const form of initialValues.forms) {
        if (name in form) {
          return form[name];
        }
      }
    }
    return undefined;
  };

  const validateInput = (inputValue:string) => {
    if (hidden) {
      updateFieldValidationStatus(id, true);
      return '';
    }
    if (required && !inputValue.trim()) {
      updateFieldValidationStatus(id, false);
      return requiredmessage ?? 'This field is required';
    }
    if (format) {
      if (format.type === 'numeric') {
        const numberValue = Number(inputValue);
        if (isNaN(numberValue)) {
          updateFieldValidationStatus(id, false);
          return format.typemessage ?? 'This field must be a numeric value';
        }
        if (format.min !== undefined && numberValue < format.min) {
          updateFieldValidationStatus(id, false);
          return format.minmessage ?? `This field must be greater than ${format.min - 1}`;
        }
        if (format.max !== undefined && numberValue > format.max) {
          updateFieldValidationStatus(id, false);
          return format.maxmessage ?? `This field must be less than ${format.max}`;
        }
      }
    }
    updateFieldValidationStatus(id, true);
    return '';
  };

  const customOnChange = (event: any) => {
    const inputValue = event.target.value;

    const validationError = validateInput(inputValue);
    setError(validationError);

    onChange(event);
    formik.handleChange(event);
    setDisplayValue(inputValue);
  };

  return (
    <div>
      <label htmlFor={id} data-testid={name} className="fw-bold mb-0">{label}</label>
      <br />
      <Field
        type={type}
        id={id}
        name={name}
        className={`${readonly ? 'readonly-textbox ' : 'textbox form-control'} ${error ? 'error-textbox' : ''}`}
        placeholder={placeHolder ? placeHolder : ''}
        key={name}
        onChange={customOnChange}
        disabled={readonly}
        value={displayValue}
      />
      {error && <ErrorMessage message={error} />}
    </div>
  );
};

const ErrorMessage: React.FC<{ message:string }> = ({ message }) => <div className="error-message">{message}</div>;

export default TextBox;
